/** Limites alinhados à API e ao header do app (PersonalNutri.App) */
export const SURVEY_LIMITS = {
  APP_TITLE_MAX: 42,
  INTERNAL_TITLE_MAX: 120,
  WELCOME_MESSAGE_MAX: 400,
  THANK_YOU_MESSAGE_MAX: 200,
  QUESTION_PROMPT_MAX: 150,
  QUESTION_HELP_MAX: 100,
  PUSH_TITLE_MAX: 50,
  PUSH_BODY_MAX: 120,
};
